<pr-input-select-template
  formControlName="avClauseBeneficiaire"
  [options]="options"
>
  <ng-template #optionTemplate let-option let-id="index">
    <div>
      <div>
        <beneficiary-box
          [suffix]="option.suffix"
          [title]="option.label"
          [svg]="option.svg"
        ></beneficiary-box>
      </div>
    </div>
  </ng-template>
</pr-input-select-template>
<!-- ngSwitch beneficiary  -->

@switch (form.get('avClauseBeneficiaire')?.value) {
  @case ('STANDARD') {
    <beneficiary-death-insured [derrors]="derrors"></beneficiary-death-insured>
  }
  @case ('LIBRE') {
    @if (!isCorumProduct) {
      <beneficiary-clause [derrors]="derrors"></beneficiary-clause>
    }
    @if (isCorumProduct) {
      <beneficiary-clause-beneficiaire
        [formGroup]="form"
        formArrayName="avClauseBeneficiaireBeneficiaires"
        [derrors]="derrors"
      ></beneficiary-clause-beneficiaire>
    }
  }
  @case ('NOTARIALE') {
    <notary-info [derrors]="derrors"></notary-info>
  }
}
